/**
 * Application configuration
 */

// API URL for production and development environments
export const API_URL = import.meta.env.VITE_API_URL || 'https://chat-sphere-58as.onrender.com';

// More detailed logging for debugging
console.log('Environment variables available:', import.meta.env);
console.log('VITE_API_URL from env:', import.meta.env.VITE_API_URL);
console.log('Using API URL:', API_URL);

// Configuration object
export const config = {
  apiUrl: API_URL,
  maxMessageLength: 1000,
  messageExpirationTime: {
    public: 60 * 60 * 1000, // 1 hour in milliseconds
    private: 7 * 24 * 60 * 60 * 1000 // 7 days in milliseconds
  },
  reconnectionAttempts: 5,
  socketOptions: {
    transports: ['websocket', 'polling'], // Allow polling as fallback
    reconnectionDelay: 1000,
    reconnectionAttempts: 5,
    timeout: 20000,
    autoConnect: true,
    forceNew: true
  },
  debug: {
    logApiCalls: true,
    logSocketEvents: true
  }
};

// Export default config
export default config; 